const AppRoutes = {
  MAIN: "/",
  ADD: "/add",
  EDIT: "/edit/:id",
};

export default AppRoutes;
